import { MdChevronRight } from "react-icons/md"
import ScrollContainer from "react-indiana-drag-scroll"
import Institutes from "./institutes"
import SideMenu from "../sideMenu/sideMenu"
import Banner from "../banner/banner"
import AnimatedPage from "../animatedPage"
import { FaArrowRight } from "react-icons/fa6"
import { useRef, useState } from "react"
import { PropTypes } from 'prop-types';
import Happening from "./happening"
import ModelButton from "../modelBtn/modelButton"
import ContactUsPopUp from "./irmc/contactUsPopUp"


const Pages = ({ text, bg, list, contactUs, contents }) => {
    const happenings = [
        {
            date: "10 May 2023",
            title: "34th INTERNATIONAL INVENTION, INNOVATION & TECHNOLOGY EXHIBITION (ITEX '23)",
            description: "UNITEN is committed to become a globally competitive.....read more",
            children:
                <div className="grid gap-5">
                    <div className="grid">
                        <p className="w-auto  text-justify   text-base font-normal leading-normal">{`UNITEN is committed to become a globally competitive and energy-focused university. We are keen to identify opportunities, research and programmes that correspond to the long term needs of our stakeholders.`}</p>
                        <p className="w-auto  text-justify   text-base font-normal leading-normal">{`More than RM100 million research grants and consultancy projects have been secured by UNITEN's researchers so far. UNITEN continually develops partnerships that foster interdisciplinary work.`}</p>
                    </div>
                    <p className="w-auto  text-justify   text-base font-normal leading-normal">{`Click the link below to download:`}</p>
                    <a href="https://www.uniten.edu.my/media/6734/itex-23_fa.pdf" className="text-[#337AB7] underline underline-1">eBooklet ITEX&apos;23</a>
                </div>
        },
        {
            date: "12 November 2021",
            title: "2nd Symposium on Energy and environment 2021 (SEE2021)",
            description: "2nd Symposium on Energy and environment 2021 (S.....read more",
            children:
                <div className="grid gap-5">
                    <p className="w-auto  text-justify   text-base font-normal leading-normal">{`2nd Symposium on Energy and environment 2021 (SEE2021)`}</p>
                    <p className="w-auto  text-justify   text-base font-normal leading-normal">{`Submission page for each track as as follows:`}</p>
                    <ul className="list-disc ml-5 text-[#337AB7]">
                        <li>Energy & environment </li>
                        <li>Electronics & communication</li>
                        <li>Energy informatics </li>
                        <li>Energy business & economics </li>
                        <li>Energy related education </li>

                    </ul>
                </div>
        },
        {
            date: "18 February 2020",
            title: "Malaysia Technology Expo (MTE2020) Booklet",
            description: "UNITEN is committed to become a globally competitive.....read more",
            children:
                <div className="grid gap-5">
                    <p className="w-auto  text-justify   text-base font-normal leading-normal">{`Malaysia Technology Expo (MTE 2020)`}</p>
                    <p className="w-auto  text-justify   text-base font-normal leading-normal">{`The 19th International Expo on Inventions and Innovations`}</p>
                    <p className="w-auto  text-justify   text-base font-normal leading-normal">{`Date : 20 - 22 FEBRUARY 2020`}</p>
                    <p className="w-auto  text-justify   text-base font-normal leading-normal">{`Venue : Putra World Trade Centre, Kuala Lumpur`}</p>
                    <p className="w-auto  text-justify   text-base font-normal leading-normal text-[#337AB7]">Download booklet</p>
                </div>
        },
        {
            date: "10 May 2023",
            title: "FRGS 2019-1 Workshop with Head of Research Domain",
            description: "UNITEN is committed to become a globally competitive.....read more"
        },
        {
            date: "10 May 2023",
            title: "FRGS 2019-1 Workshop with Head of Research Domain",
            description: "UNITEN is committed to become a globally competitive.....read more"
        },
        {
            date: "10 May 2023",
            title: "FRGS 2019-1 Workshop with Head of Research Domain",
            description: "UNITEN is committed to become a globally competitive.....read more"
        },
        {
            date: "10 May 2023",
            title: "FRGS 2019-1 Workshop with Head of Research Domain",
            description: "UNITEN is committed to become a globally competitive.....read more"
        },

    ]
    const container = useRef(null);

    const handleScroll = () => {
        if (container.current) {
            container.current.scrollBy({ left: 500, behavior: "smooth" })
        }

    }
    const [modalOpen, setModalOpen] = useState(false);

    const closed = () => setModalOpen(false);
    const open = () => contactUs != undefined && setModalOpen(true);

    return (
        <AnimatedPage>
            <Banner text={text} bg={bg} />
            <div className="flex justify-center bg-white p-4 md:py-12 w-full">
                <div className="w-full flex flex-col gap-5 lg:px-16  ">
                    <SideMenu list={list} contents={contents}>
                        <div className="p-4 flex items-center w-full my-8">
                            <div className="flex w-full flex-col gap-3  py-10 items-center rounded-lg bg-[#02265B]">
                                <h2 className="w-auto max-w-[20ch] text-center font-bold text-white text-xl leading-tight">{`Contact Us`}</h2>
                                <>
                                    <button
                                        onClick={() => ( modalOpen ? closed() : open())}
                                        className="px-8 py-4 w-fit  bg-red-800 rounded justify-center items-center gap-4 flex">
                                        <span className="text-white  text-base font-bold capitalize flex items-center gap-3">View Details <FaArrowRight /></span>
                                    </button>
                                    <ModelButton modalOpen={modalOpen} close={closed}>
                                        <ContactUsPopUp contactUs={contactUs} />

                                    </ModelButton>
                                </>

                            </div>
                        </div>
                    </SideMenu>
                </div>
            </div>
            <div className="px-4 py-8 md:px-24 grid gap-16 my-8">
                <div className="grid gap-5 relative">
                    <div className="border-b border-b-[#393939] w-full py-2">
                        <h2 className="text-2xl font-bold">happenings</h2>

                    </div>
                    < ScrollContainer innerRef={container}

                        horizontal className="flex  gap-5 w-full   scroll-smooth snap-mandatory snap-x overflow-x-auto scroll-px-3 p-2 mt-2 ">
                        {
                            happenings.map((happening, index) => {
                                return (
                                    <Happening happening={happening} key={index} />
                                )
                            }
                            )

                        }
                    </ScrollContainer>
                    <div onClick={handleScroll} className="w-12 h-12 absolute top-1/2 -translate-y-1/2 right-0 select-none font-bold shadow border cursor-pointer rounded-full bg-white grid place-items-center">
                        <MdChevronRight size={30} />
                    </div>
                </div>
                <Institutes />
            </div>
        </AnimatedPage>
    )
}
Pages.propTypes = {
    text: PropTypes.string,
    bg: PropTypes.string,
    list: PropTypes.array,
    contactUs: PropTypes.any,
    contents: PropTypes.array
}
export default Pages